import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Etioncabserviceinshirdi() {



    const cardData = {





keyword: "Etios Cab Service in Shirdi",

headingDescription: "Sai Shirdi Cab provides reliable Etios Cab Service in Shirdi for devotees, families, tourists, corporate travelers, and small groups looking for comfortable and economical outstation transportation from Shirdi. Customers can hire an Etios with a professional driver for one-way journeys, round trips, pilgrimage trips, family travel, business visits, sightseeing, and customized outstation tours. The Etios is a practical choice for passengers who want comfortable seating, sufficient luggage space, and convenient door-to-door transportation for long-distance travel. Customers can book Etios cab service from Shirdi to popular destinations such as Nashik, Chhatrapati Sambhajinagar, Ahmednagar, Pune, Mumbai, Shani Shingnapur, Trimbakeshwar, Bhimashankar, Saptashrungi, and Ajanta-Ellora. Sai Shirdi Cab provides clean and well-maintained vehicles, experienced drivers, flexible pickup timings, and convenient booking options for individual travelers, families, and small groups.",

topPlaces: [
{
title: "Nashik",
description: "Nashik is a popular outstation destination from Shirdi for pilgrimage, sightseeing, family trips, and business travel. Customers can book an Etios cab for comfortable transportation from Shirdi to Nashik. The journey can also include Trimbakeshwar and other nearby destinations according to the planned itinerary."
},
{
title: "Chhatrapati Sambhajinagar",
description: "Chhatrapati Sambhajinagar is a popular destination from Shirdi for heritage sightseeing, family travel, business visits, and religious trips. An Etios provides a practical and comfortable option for individuals and small families. One-way and round-trip cab services can be arranged according to the travel requirement."
},
{
title: "Ahmednagar",
description: "Ahmednagar is a convenient outstation destination from Shirdi for business, family visits, and personal travel. Customers can hire an Etios with a professional driver for direct or round-trip journeys. The vehicle is suitable for passengers looking for comfortable transportation with useful luggage space."
},
{
title: "Pune",
description: "Pune is an important outstation destination from Shirdi for corporate travel, family visits, education, medical appointments, and tourism. Customers can book an Etios for direct travel from Shirdi to Pune. The car is suitable for individuals, couples, and small families traveling with normal luggage."
},
{
title: "Mumbai",
description: "Mumbai is a major long-distance destination from Shirdi for business travel, tourism, family visits, and airport connectivity. Customers can hire an Etios with a professional driver for convenient private transportation. One-way and round-trip options can be customized according to the travel schedule."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is a popular pilgrimage destination that can be visited from Shirdi by private Etios cab. Devotees and families can book a comfortable round trip for temple visits without depending on public transportation. The journey can also include other nearby religious destinations."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is an important Jyotirlinga pilgrimage destination that can be covered from Shirdi by Etios. Customers can plan a private religious journey and combine Trimbakeshwar with Nashik or other nearby places. The vehicle is suitable for small families and groups."
},
{
title: "Bhimashankar",
description: "Bhimashankar is a prominent pilgrimage destination that can be included in an outstation trip from Shirdi. Customers can hire an Etios for a dedicated round trip with flexible pickup and return timings. The service is suitable for devotees and families planning a comfortable private journey."
},
{
title: "Saptashrungi",
description: "Saptashrungi Devi Temple at Vani is a popular religious destination that can be visited from Shirdi by private Etios. Customers can plan a family pilgrimage trip with convenient pickup and return arrangements. Saptashrungi can also be combined with Nashik and other nearby destinations."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta and Ellora Caves are popular heritage attractions that can be covered from Shirdi through an outstation Etios cab. Customers can plan a full-day or multi-day sightseeing trip with flexible stops. The vehicle is a practical option for small families and travelers carrying moderate luggage."
}
],








"services": [
{
"name": "Etios Cab Service in Shirdi",
"description": "Etios Cab Service in Shirdi provides a comfortable and practical private transportation option for individuals, families, and small groups. The cab can be arranged for local travel, Sai Baba darshan, sightseeing, airport transfers, railway station pickups, and outstation journeys."
},
{
"name": "Etios Taxi Service in Shirdi",
"description": "Etios Taxi Service in Shirdi offers convenient point-to-point transportation for passengers traveling within Shirdi or toward other destinations. Taxi arrangements can be planned according to passenger count, luggage requirements, pickup location, travel timing, and one-way or round-trip needs."
},
{
"name": "Etios Cab Shirdi",
"description": "Etios Cab Shirdi provides a reliable private vehicle option for travelers requiring comfortable transportation around Shirdi. Customers can arrange the cab for temple visits, sightseeing, hotel transfers, railway station travel, airport transportation, and longer intercity journeys."
},
{
"name": "Etios Taxi Shirdi",
"description": "Etios Taxi Shirdi offers a practical travel solution for passengers looking for a comfortable sedan-style vehicle. The taxi can be scheduled according to the preferred pickup point, destination, travel date, passenger requirements, luggage, and selected journey type."
},
{
"name": "Etios Car Rental Shirdi",
"description": "Etios Car Rental Shirdi provides a convenient private vehicle rental option for local and outstation travel. Customers can plan the rental according to the required duration, travel itinerary, passenger count, luggage, pickup location, destination, and one-way or return requirements."
},
{
"name": "Etios Cab Booking Shirdi",
"description": "Etios Cab Booking Shirdi allows travelers to reserve a suitable private cab in advance for planned transportation. Booking details can include the travel date, pickup timing, passenger count, luggage requirements, destination, vehicle preference, and one-way or round-trip journey."
},
{
"name": "Etios Taxi Booking Shirdi",
"description": "Etios Taxi Booking Shirdi provides a convenient way to arrange private taxi transportation for local, pilgrimage, sightseeing, and outstation travel. Customers can schedule the taxi according to their preferred pickup location, travel time, destination, passenger capacity, and trip requirements."
},
{
"name": "Etios on Rent in Shirdi",
"description": "Etios on Rent in Shirdi offers a practical vehicle option for travelers requiring private transportation for personal or family journeys. The rental can be arranged for local trips, sightseeing, temple visits, airport transfers, railway station pickups, and outstation travel."
},
{
"name": "Etios Car on Rent Shirdi",
"description": "Etios Car on Rent Shirdi provides convenient sedan transportation for individuals, families, and small groups. Customers can select suitable rental arrangements based on travel duration, passenger requirements, luggage, pickup location, destination, and preferred one-way or round-trip itinerary."
},
{
"name": "Etios With Driver Shirdi",
"description": "Etios With Driver Shirdi provides chauffeur-driven transportation for travelers who prefer a convenient private travel experience. The vehicle can be arranged for Sai Baba darshan, local sightseeing, airport transfers, railway station pickups, hotel transfers, and outstation journeys."
},
{
"name": "Etios Outstation Cab Shirdi",
"description": "Etios Outstation Cab Shirdi is suitable for passengers planning private long-distance journeys from Shirdi to nearby cities and other destinations. The cab can be arranged according to route, travel duration, passenger count, luggage requirements, pickup point, and one-way or round-trip preferences."
},
{
"name": "Etios One Way Cab Shirdi",
"description": "Etios One Way Cab Shirdi provides direct private transportation for travelers who need a single journey without arranging a return trip. The cab can be scheduled from the preferred pickup location in Shirdi to the selected destination according to the travel date and passenger requirements."
},
{
"name": "Etios Round Trip Cab Shirdi",
"description": "Etios Round Trip Cab Shirdi is suitable for passengers planning an onward journey and return to Shirdi. The trip can be organized according to travel dates, stay duration, passenger count, luggage, waiting requirements, destination, and preferred return schedule."
},
{
"name": "Etios Airport Cab Shirdi",
"description": "Etios Airport Cab Shirdi provides convenient sedan transportation for airport pickup and drop requirements around Shirdi. The cab can be coordinated with flight timings and arranged according to passenger count, luggage, airport location, pickup schedule, and final destination."
},
{
"name": "Etios Railway Station Cab Shirdi",
"description": "Etios Railway Station Cab Shirdi offers private transportation for passengers arriving at or departing from railway stations near Shirdi. Pickup and drop services can be scheduled according to train timings, passenger requirements, luggage, pickup point, and destination."
},
{
"name": "Etios Local Cab Shirdi",
"description": "Etios Local Cab Shirdi provides convenient transportation for travelers moving around Shirdi and nearby areas. The cab can be used for temple visits, hotel transfers, local sightseeing, shopping, railway station travel, and other short-distance transportation requirements."
},
{
"name": "Etios Tourist Cab Shirdi",
"description": "Etios Tourist Cab Shirdi is a practical option for individuals and small families exploring Shirdi and nearby tourist or pilgrimage destinations. The cab can be arranged for sightseeing, temple visits, local tours, family outings, and customized travel itineraries."
},
{
"name": "Etios Darshan Cab Shirdi",
"description": "Etios Darshan Cab Shirdi provides private transportation for devotees visiting Sai Baba Temple and other nearby pilgrimage locations. The cab can be scheduled according to darshan plans, passenger count, pickup location, travel timing, luggage requirements, and preferred itinerary."
},
{
"name": "Affordable Etios Cab Service Shirdi",
"description": "Affordable Etios Cab Service Shirdi provides a practical sedan transportation option for travelers looking for comfortable travel within their planned budget. The service can be arranged according to passenger count, travel distance, journey type, pickup location, luggage, and itinerary requirements."
},
{
"name": "Etios Taxi Booking Online Shirdi",
"description": "Etios Taxi Booking Online Shirdi allows travelers to arrange a private sedan taxi in advance for their planned journey. Customers can provide travel dates, pickup details, passenger count, luggage requirements, destination, preferred timing, and one-way or round-trip transportation needs."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides Etios and other suitable private vehicles for local travel, Sai Baba darshan, sightseeing, airport transfers, railway station pickups, family journeys, and outstation transportation. Vehicle arrangements can be planned according to passenger count, luggage, travel schedule, and destination."
}
],
"tableData": [
["Etios Cab Service in Shirdi", "Etios Taxi Service in Shirdi"],
["Etios Cab Shirdi", "Etios Taxi Shirdi"],
["Etios Car Rental Shirdi", "Etios Cab Booking Shirdi"],
["Etios Taxi Booking Shirdi", "Etios on Rent in Shirdi"],
["Etios Car on Rent Shirdi", "Etios With Driver Shirdi"],
["Etios Outstation Cab Shirdi", "Etios One Way Cab Shirdi"],
["Etios Round Trip Cab Shirdi", "Etios Airport Cab Shirdi"],
["Etios Railway Station Cab Shirdi", "Etios Local Cab Shirdi"],
["Etios Tourist Cab Shirdi", "Etios Darshan Cab Shirdi"],
["Affordable Etios Cab Service Shirdi", "Etios Taxi Booking Online Shirdi"],
["Sai Shirdi Cabs", "Etios Cab Service in Shirdi"]
]
,








    whychoose: [
        { 
            WhyChooseheading: "Etios Cab Service in Shirdi for Comfortable Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs provides Etios cab service in Shirdi for devotees, families, tourists, business travellers, and small groups. Etios can be arranged for Sai Baba Darshan, local sightseeing, hotel transfers, railway station pickups, airport transfers, and outstation journeys from Shirdi according to your travel requirements." 
        }, 
        { 
            WhyChooseheading: "Practical Sedan for Local & Outstation Trips", 
            WhyChoosedescription: "Etios is a practical sedan option for passengers looking for a comfortable private vehicle for short or long-distance travel. It can be suitable for couples, small families, and travellers carrying regular luggage." 
        }, 
        { 
            WhyChooseheading: "Etios for Sai Baba Darshan", 
            WhyChoosedescription: "Devotees can book an Etios for travelling between their hotel, Sai Baba Temple, railway station, and nearby pilgrimage locations. A private cab provides convenient transportation according to the planned Darshan schedule." 
        }, 
        { 
            WhyChooseheading: "Etios Cab for Shirdi Sightseeing", 
            WhyChoosedescription: "Explore Shirdi and nearby attractions with a private Etios cab according to your preferred sightseeing itinerary. Travellers can plan multiple stops based on their available time and destinations." 
        }, 
        { 
            WhyChooseheading: "Airport & Railway Station Transfers", 
            WhyChoosedescription: "Etios cab service can be arranged for airport and railway station pickup or drop services in and around Shirdi. Passengers can share their flight or train details to coordinate the required transportation." 
        }, 
        { 
            WhyChooseheading: "One-Way & Round-Trip Cab Options", 
            WhyChoosedescription: "Choose a one-way Etios cab when you need direct transportation to another destination, or arrange a round-trip service when you require transportation for both onward and return journeys from Shirdi." 
        }, 
        { 
            WhyChooseheading: "Etios for Outstation Travel from Shirdi", 
            WhyChoosedescription: "Book an Etios for outstation journeys from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Ahmednagar, and other cities or tourist destinations according to your travel plans." 
        }, 
        { 
            WhyChooseheading: "Book Etios Cab Service in Shirdi with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, luggage details, trip duration, one-way or round-trip requirement, and preferred travel schedule with Sai Shirdi Cabs to arrange an Etios cab for your journey." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I book an Etios Cab in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides Etios cab service in Shirdi for local travel, Sai Baba Darshan, sightseeing, airport transfers, railway station travel, and outstation journeys." 
    }, 
    { 
        question: "Is Etios suitable for Sai Baba Darshan?", 
        answer: "Yes, Etios is a practical sedan option for devotees travelling between hotels, Sai Baba Temple, railway stations, and nearby pilgrimage locations in Shirdi." 
    }, 
    { 
        question: "Can I book an Etios for Shirdi sightseeing?", 
        answer: "Yes, a private Etios can be arranged for Shirdi sightseeing and nearby attractions according to your preferred itinerary and travel schedule." 
    }, 
    { 
        question: "Can I book Etios for airport transfers in Shirdi?", 
        answer: "Yes, Etios cab service can be arranged for airport pickup and drop according to your flight schedule and passenger requirements." 
    }, 
    { 
        question: "Can I book Etios from Shirdi Railway Station?", 
        answer: "Yes, Etios can be arranged for railway station pickup or drop according to your train schedule, passenger count, and luggage requirements." 
    }, 
    { 
        question: "Can I book an Etios for one-way travel from Shirdi?", 
        answer: "Yes, one-way Etios cab service can be arranged for passengers who require direct transportation from Shirdi to another destination without requiring the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I book Etios for a round trip from Shirdi?", 
        answer: "Yes, round-trip Etios cab service can be arranged for travellers who need transportation to their destination and back to Shirdi according to their planned schedule." 
    }, 
    { 
        question: "Is Etios available for outstation travel from Shirdi?", 
        answer: "Yes, Etios can be booked for outstation journeys from Shirdi to various cities, tourist destinations, and pilgrimage locations according to your travel requirements." 
    }, 
    { 
        question: "Can I book Etios for a multi-day trip?", 
        answer: "Yes, multi-day Etios cab arrangements can be discussed for extended sightseeing tours, pilgrimage journeys, family trips, and multi-city travel from Shirdi." 
    }, 
    { 
        question: "How can I book Etios Cab Service in Shirdi?", 
        answer: "Share your pickup point, destination, travel date, passenger count, luggage details, trip duration, and one-way or return requirement with Sai Shirdi Cabs to proceed with the Etios cab booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Rahul Patil", 
        feedback: "We booked an Etios in Shirdi for our family Darshan and local sightseeing. The sedan was a practical choice for our small group and made travelling between the planned locations convenient.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Sunita More", 
        feedback: "Our family used an Etios for an outstation journey from Shirdi. The private cab was convenient for travelling together with our luggage and following our planned schedule.", 
        rating: 5 
    } 
];








    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Etios Cab Service in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/etios-cab-service-in-shirdi.webp",
  "description":
    "Book Etios Cab Service in Shirdi with Sai Shirdi Cabs for comfortable, convenient, and reliable local and outstation travel. Our Etios cab service is suitable for Sai Baba Darshan, Shirdi sightseeing, airport transfers, railway station transfers, one-way journeys, round trips, and outstation travel. Get a well-maintained Etios with a professional driver, convenient pickup and drop locations, affordable fares, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/etios-cab-service-in-shirdi"
  }
};




    return (
        <div>


<Helmet>
  <title>Etios Cab Service in Shirdi | Etios Taxi Service | +91 7776814559</title>

  <meta
    name="description"
    content="Book Etios Cab Service in Shirdi with Sai Shirdi Cabs for Sai Baba Darshan, sightseeing, airport and railway station transfers, one-way, round trips and outstation travel. Get a comfortable Etios with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="Etios Cab Service in Shirdi, Etios Taxi Service in Shirdi, Etios Cab Shirdi, Etios Taxi Shirdi, Etios car rental Shirdi, Etios cab booking Shirdi, Etios taxi booking Shirdi, Etios on rent in Shirdi, Etios car on rent Shirdi, Etios with driver Shirdi, Etios outstation cab Shirdi, Etios one way cab Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Etioncabserviceinshirdi;